// import * as dotenv from 'dotenv'

import { Refine } from '@refinedev/core'
import { DevtoolsPanel, DevtoolsProvider } from '@refinedev/devtools'
import {
  notificationProvider,
  Layout,
  ErrorComponent
} from '@refinedev/antd'

import dataProvider from '@refinedev/simple-rest'
import routerProvider from '@refinedev/react-router-v6/legacy'

// import { AntdInferencer } from '@pankod/refine-inferencer/antd'

import { Title } from './components/title'
// import { BikeWhiteIcon, PizzaIcon } from 'components/icons'
import { Header } from './components/header'
import { ColorModeContextProvider } from './contexts/color-mode'

import '@refinedev/antd/dist/reset.css'

import { Login } from './pages/login'
import resources from './resources'
import authProvider from './authProvider'

import axios from 'axios'

const axiosInstance = axios.create()

// Surface server-side error messages instead of axios's "Request failed with status code N".
// All API endpoints return { error: <message> } in the response body — promote it to
// error.message so Refine's default notification description shows something readable.
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const apiError = error?.response?.data?.error
    const status = error?.response?.status
    if (status === 409 || apiError === 'Already Exists' || apiError === 'Element already exists') {
      error.message = 'Già presente: aprilo dalla lista per modificarlo'
    } else if (apiError) {
      error.message = apiError
    }
    return await Promise.reject(error)
  }
)

const API_URL =
  (
    () => {
      if (process.env.NODE_ENV === 'development') {
        if (process.env.REACT_APP_ENV === 'testnet') {
          return 'http://localhost:22222/api'
        } else {
          return 'http://localhost:11111/api'
        }
      }
      return '/api'
    }
  )()

const RefineProvider = (): any => {
  return (
    (
      <ColorModeContextProvider>
        <DevtoolsProvider>
          <Refine
            dataProvider={dataProvider(API_URL, axiosInstance)}
            legacyRouterProvider={{
              ...routerProvider,
              routes: [
                {
                  element: <Login />,
                  path: '/login'
                }
              ]
            }}
            authProvider={authProvider(API_URL, axiosInstance)}
            LoginPage={Login}
            resources={resources}
            notificationProvider={notificationProvider}
            Title={Title}
            Layout={Layout}
            Header={Header}
            catchAll={<ErrorComponent />}
            options={{
              projectId: 'HWOwA8-XQnok5-E0Bd05'
            }}
          >
            <DevtoolsPanel />
          </Refine>
        </DevtoolsProvider>
      </ColorModeContextProvider>
    )
  )
}

const App = (): any => {
  return RefineProvider()
}

export default App
